import { useEffect, useState } from 'react';
import { ScreenLoader } from 'components/Loader/ScreenLoader';
import { postAccountsLink } from 'store/recipients/actions';
import { useAppSelector } from 'helpers/hooks';
import { getSelectedRecipientId, getActiveRole, getAdminsOBCheck } from 'selectors/admins';
import { useGetAdminsRecipientsQuery } from 'services/adminsApi';
import { useAuth0Config } from 'hooks/useAuth0Config';
import { OnboardingStatusOpts } from 'store/admins/types';
import { getIsRecipient } from 'config/permissions';

export const StripeOnboardingRefresh = () => {
  useAuth0Config();
  const [loaderText, setLoaderText] = useState('Redirecting to Stripe Onboarding');

  const activeRole = useAppSelector(getActiveRole);
  const recipient_id = useAppSelector(getSelectedRecipientId);
  const OBCheck = useAppSelector(getAdminsOBCheck);

  // Fetch recipients using RTK Query - automatically fetches when activeRole is available
  useGetAdminsRecipientsQuery(undefined, {
    skip: !activeRole || !getIsRecipient(activeRole),
  });

  useEffect(() => {
    if (!recipient_id || !activeRole) {
      return;
    }
    postAccountsLink(
      {
        recipient_id,
        type:
          OBCheck && OBCheck.onboarding_status === OnboardingStatusOpts.COMPLETE
            ? 'account_update'
            : 'account_onboarding',
      },
      activeRole
    )
      .then(response => {
        if (response.url) {
          window.location.href = response.url;
        }
      })
      .catch(() => {
        setLoaderText(
          'Sorry, there was an error redirecting to Stripe Onboarding. Please contact support.'
        );
      });
  }, [recipient_id, activeRole]);

  return <ScreenLoader text={loaderText} />;
};
